function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Compose"
}, React.createElement("path", {
  className: "cls-1",
  d: "M13.732,2.508,11.563.339a.916.916,0,0,0-1.3,0L5.493,5.169,4.832,8.2a.917.917,0,0,0,1.09,1.09l3.035-.661L13.735,3.8A.915.915,0,0,0,13.732,2.508Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M11.99,8.81h-.408a1.015,1.015,0,0,0-1,1.011V11.51H2.419V3.349H4.106a1.011,1.011,0,0,0,1.01-1.01V1.931a1.013,1.013,0,0,0-1.01-1h-3.1a1,1,0,0,0-.976.845A1.069,1.069,0,0,0,0,1.932V12.919H0a1,1,0,0,0,.266.669c.012.013.017.031.03.044s.027.016.039.026a1,1,0,0,0,.674.27H11.99a1,1,0,0,0,.669-.266c.013-.012.032-.017.044-.03s.018-.031.03-.044A1,1,0,0,0,13,12.92h0v-3.1A1.011,1.011,0,0,0,11.99,8.81Z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/window.89583cf8.svg";
export { SvgComponent as ReactComponent };